export default __webpack_public_path__ + "static/media/facebookLogo.ad57e637.svg";